import styled from 'styled-components';

import { Text } from '../../../Text';

export const RadioLabel = styled(Text)`
    cursor: pointer;
`;

export const RadioCircle = styled.span<{ $checked?: boolean }>`
    height: 16px;
    width: 16px;
    border-radius: 50%;
    border: 1px solid ${({ theme }) => theme.border.dark};
    margin-right: 8px;
    position: relative;
    cursor: pointer;
    flex-shrink: 0;

    &:before {
        content: '';
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border: 2px solid ${({ theme }) => theme.border.light};
        background-color: ${({ theme }) => theme.intent.info};
        display: ${({ $checked }) => ($checked ? 'block' : 'none')};
        position: absolute;
        box-sizing: border-box;
    }
`;

export const RadioOption = styled.label`
    display: inline-flex;
    position: relative;
    align-items: center;
`;

export const RadioInput = styled.input`
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;

    &:disabled {
        & ~ ${RadioCircle} {
            cursor: not-allowed;
            background-color: ${({ theme }) => theme.intent.disabled};
        }
        & ~ ${RadioLabel} {
            cursor: not-allowed;
            color: ${({ theme }) => theme.text.disabled};
        }
    }
`;
